import {
    ActionIcon,
    Badge,
    Box,
    Flex,
    Indicator,
    Paper,
    Text,
    useMantineTheme,
    Tooltip,
    Button,
} from "@mantine/core";
import {
    IconArrowBigDown,
    IconArrowBigTop,
    IconArrowBigUpLine,
    IconArrowBigUpLines,
    IconArrowUp,
    IconLink,
    IconReload,
    IconThumbDown,
    IconThumbUp,
} from "@tabler/icons";
import { useSession } from "next-auth/react";
import SlateEditorComponent from "./SlateEditorComponent";
import { useState } from "react";
import { formatDateAgo } from "../common/commonfunc";
import ProfilePicture from "./ProfilePicture";
import Feedback from "./Feedback";
import Link from "next/link";
import MyMarkdown from "./MyMarkdown";

const CommentUI = ({
    questionid = null,
    questionText = null,
    downvotes = null,
    upvotes = null,
    heading = null,
    comment,
    idx,
    commentid = null,
    created_at = null,
    user = null,
}) => {
    // const { data: session, status } = useSession();
    const highlight = idx == 0;
    const discuss_url = `/discuss/${commentid}`;
    let share_message = `${
        !!heading ? heading + "%0a" : "%0aSolution :%0a"
    } ${comment}%0a`;

    if (!!commentid) {
        share_message = `${
            !!heading ? heading + " : %0a" : "%0aSolution :%0a"
        } ${discuss_url} `;
    }

    return (
        <Paper
            pr="lg"
            py="xs"
            radius="md"
            sx={(theme) => ({
                backgroundColor:
                    theme.colorScheme == "dark"
                        ? theme.colors.dark[6]
                        : theme.colors.gray[2],
                border: highlight
                    ? theme.colorScheme == "dark"
                        ? `5px dashed ${theme.colors.dark[5]}`
                        : `5px dashed ${theme.colors.gray[4]}`
                    : "",
                position: "relative",
                "&:hover": {
                    backgroundColor:
                        theme.colorScheme == "dark"
                            ? theme.colors.dark[5]
                            : theme.colors.gray[3],
                },
            })}
        >
            <Flex gap={10}>
                <Flex direction={"column"} justify={"center"}>
                    {/* <Text ta={"center"} fz={"lg"}>
                        {upvotes}
                    </Text> */}
                    {/* <Tooltip label="Upvote">
                        <ActionIcon color={"green.5"}>
                            <IconArrowBigTop />
                        </ActionIcon>
                    </Tooltip>
                    <Tooltip label="Downvote">
                        <ActionIcon color={"red.5"}>
                            <IconArrowBigDown />
                        </ActionIcon>
                    </Tooltip> */}
                    {/* <Text ta={"center"} fz={"lg"}>
                        {downvotes}
                    </Text> */}
                </Flex>
                {!!user && (
                    <Box sx={{ position: "absolute", top: -20, left: -20 }}>
                        <ProfilePicture size="lg" {...user} />
                    </Box>
                )}
                <Flex pl={"md"} direction={"column"} sx={{ flexGrow: 1 }}>
                    <Flex
                        justify={"space-between"}
                        wrap={"wrap"}
                        align={"center"}
                    >
                        <Link
                            href={discuss_url}
                            target={"_blank"}
                            passHref
                            legacyBehavior
                        >
                            <Box>
                                <Flex
                                    gap={10}
                                    sx={{
                                        cursor: "pointer",
                                        flexGrow: 1,
                                        "&:hover": {
                                            textDecoration: "underline",
                                        },
                                    }}
                                >
                                    <Text fz={"xl"} component={"h2"} m={0}>
                                        {!!heading
                                            ? heading
                                            : idx == 0
                                            ? "Solution :"
                                            : "Alternative Solution :"}
                                    </Text>
                                    <IconLink />
                                </Flex>
                            </Box>
                        </Link>

                        <Feedback id={commentid} sharedata={share_message} />
                    </Flex>

                    <MyMarkdown>{comment}</MyMarkdown>
                    <Flex
                        gap={10}
                        justify={"space-between"}
                        sx={{ alignSelf: "end" }}
                    >
                        {!!user && (
                            <Text c="dimmed" fz={"sm"}>
                                asked by [{user.name}]
                            </Text>
                        )}
                        {!!created_at && (
                            <Text c="dimmed" fz={"sm"}>
                                asked {formatDateAgo(created_at)}
                            </Text>
                        )}

                        {/* <ActionIcon aria-label="like" color={"teal.5"}>
                            <IconThumbUp />
                        </ActionIcon>
                        <ActionIcon aria-label="dislike" color={"red.5"}>
                            <IconThumbDown />
                        </ActionIcon> */}
                    </Flex>
                </Flex>
            </Flex>
        </Paper>
    );
};

export default CommentUI;
